/// <reference path="../UrlTemplate.js" />
/// <reference path="../TextResource.js" />

EasierLevelInstance = null;

class EasierLevel {
	constructor(options, safeObserve) {
		this.trEasierLevelButton = options.trEasierLevelButton;
		this.trEasierLevelModalDescription = options.trEasierLevelModalDescription;
		this.safeObserve = safeObserve;
		EasierLevelInstance = this;
	}

	setEasierLevel(url, onSuccess) {
		axios(new UrlTemplate(url).r('PLH_level', -1).url, {
			method: 'get'
		}).then(onSuccess.bind(this));
	}

	updateModalTitle(element, previousLevel) {
		element.querySelector(".title").innerText = new TextResource(EasierLevelInstance.trEasierLevelButton).r('{number}', previousLevel).string();
	}

	updateModalDescription(element, previousLevel) {
		element.querySelector(".easierLevelText").innerText = new TextResource(EasierLevelInstance.trEasierLevelModalDescription).r('{number}', previousLevel).string()
	}

	updateEasierLevelButtonText(element, previousLevel) {
		element.innerText = new TextResource(EasierLevelInstance.trEasierLevelButton).r('{number}', previousLevel).string();
	}

	initializeEasierLevel(context) {
		waitForElementToBePresent(".mia-EasierLevelModal").then(EasierLevelInstance.initializeEasierLevelModal.bind(context));

		// The EasierLevelButton is shown only when the more-options menu is opened, and after it is closed, the element is deleted.
		// GameSettingsMenu.vue calls onGameSettingsMenuOpen() directly (via the global
		// EasierLevelInstance) once the menu's contents have actually rendered.
		waitForElementToBePresent(".mia-GameSettingsMenu").then(function(element) {
			EasierLevelInstance.onGameSettingsMenuOpen = EasierLevelInstance.onGameSettingsMenuClick.bind(context, element);
		});
	}

	onGameSettingsMenuClick(element) {
		var easierLevelButtonElement = element.querySelector(".mia-easierLevelButton");
		if (!easierLevelButtonElement) {
			return;
		}

		if (document.querySelector("#levelUpScreen").style.display === "none" && document.querySelector("#typingGameTouchDevicesScreen") === null) {
			easierLevelButtonElement.style.display = "";
			EasierLevelInstance.initializeEasierLevelButton.call(this, easierLevelButtonElement);
			EasierLevelInstance.initializeEasierLevelButtonText.call(this, easierLevelButtonElement.querySelector(".mia-easierLevelButtonText"));
		} else {
			easierLevelButtonElement.style.display = "none";
		}
	}

	initializeEasierLevelModal(element) {
		var previousLevel = this.level - 1;
		EasierLevelInstance.updateModalTitle(element, previousLevel);
		EasierLevelInstance.updateModalDescription(element, previousLevel);
	}

	initializeEasierLevelButton(element) {
		element.style.display = this.level > this.medalMinLevel ? "" : "none";
	}

	initializeEasierLevelButtonText(element) {
		EasierLevelInstance.updateEasierLevelButtonText(element, this.level - 1)
	}
}
